<template>
  <div>
    <input type="hidden" :value="JSON.stringify(state)" :name="name" ref="mainInput" />

    <div
      class="group group--vertical"
      style="width: 100%"
      v-if="state.errorMessage"
    >
      <div class="section__spacer"></div>
      <div class="group__item">
        <div
          class="label label--error-inverted"
          v-html="state.errorMessage"
          style="line-height: 150%"
        ></div>
      </div>
      <div class="section__spacer"></div>
    </div>

    <step-registration
      :state="state"
      @update="update"
      v-if="state.currentStep === 'registration'"
      :agbUrl="agbUrl"
      :privacyUrl="privacyUrl"
    ></step-registration>
    <step-confirm
      :state="state"
      @update="update"
      v-if="state.currentStep === 'confirm'"
    ></step-confirm>
    <step-login
      :state="state"
      @update="update"
      v-if="state.currentStep === 'login'"
      :afterLoginUpdate="afterLoginUpdate"
      :passwordResetUrl="passwordResetUrl"
      :agbUrl="agbUrl"
      :privacyUrl="privacyUrl"
    ></step-login>
    <step-finished
      :state="state"
      @update="update"
      v-if="state.currentStep === 'finished'"
    ></step-finished>
    <step-update
      :state="state"
      @update="update"
      v-if="state.currentStep === 'update'"
    ></step-update>
  </div>
</template>

<script>
import StepRegistration from "./step/step-registration";
import StepLogin from "./step/step-login";
import StepConfirm from "./step/step-confirm";
import StepFinished from "./step/step-finished";
import StepUpdate from "@/components/plenigo-auth/step/step-update";

export default {
  name: "PlenigoAuth",
  components: {
    StepUpdate,
    StepLogin,
    StepRegistration,
    StepFinished,
    StepConfirm
  },
  props: {
    initState: String,
    name: String,
    agbUrl: String,
    privacyUrl: String,
    passwordResetUrl: String,
    error: String,
    afterLoginUpdate: Boolean,
  },
  data() {
    let state;
    try {
      state = JSON.parse(this.initState);
    } catch (e) {
      state = { currentStep: "registration" };
    }

    return { state };
  },
  methods: {
    update(property, value) {
      this.$set(this.state, property, value);

      this.$nextTick(() => {
        this.$refs.mainInput.dispatchEvent(
          new CustomEvent("change", this.state)
        );
      });
    }
  },
  mounted() {
    if (this.error) {
      this.update("errorMessage", this.error);
    }
  }
};
</script>

<style>
.button--primary:disabled {
  background: gray;
  border-color: gray;
  color: #eee;
  cursor: default;
}

.button--primary:disabled:hover {
  background: gray;
  border-color: gray;
  color: #eee;
  cursor: default;
}
</style>
